module.exports = __webpack_public_path__ + "static/media/faqs.2d758a8a.svg";